import TYPES from '@/modules/shared/types';

// Domain
import {
  HabitsRecommendedBudgetCalculationRepository,
} from '@/modules/flagship/habits-recommended-budget-calculation/domain/repositories/habits-recommended-budget-calculation-repository';
import {
  HabitsRecommendedBudgetCalculatorDto,
} from '@/modules/flagship/habits-recommended-budget-calculation/domain/dtos/habits-recommended-budget-calculator-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class HabitsRecommendedBudgetCalculationHttpRepository
implements HabitsRecommendedBudgetCalculationRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/habits-recommended-budget-calculation/`;

  create(recommended_budget_dto: HabitsRecommendedBudgetCalculatorDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', recommended_budget_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
